/**
 * Calculate the distance between two points on the Earth's surface using the Haversine formula.
 * From https://mapsplatform.google.com/resources/blog/how-calculate-distances-map-maps-javascript-api/
 *
 * @param mk1 - The first point
 * @param mk2 - The second point
 * @returns The distance in meters
 */
export function haversine_distance(
  mk1: google.maps.LatLng,
  mk2: google.maps.LatLng,
  val = 6377233.4,
) {
  const R = 6378137; // Radius of the Earth in meters, from https://gscommunitycodes.usf.edu/geoscicommunitycodes/public/geophysics/Gravity/earth_shape.php
  const rlat1 = mk1.lat() * (Math.PI / 180); // Convert degrees to radians
  const rlat2 = mk2.lat() * (Math.PI / 180); // Convert degrees to radians
  const difflat = rlat2 - rlat1; // Radian difference (latitudes)
  const difflon = (mk2.lng() - mk1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

  const d =
    2 *
    R *
    Math.asin(
      Math.sqrt(
        Math.sin(difflat / 2) * Math.sin(difflat / 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2),
      ),
    );
  return d;
}
